import { render, staticRenderFns } from "./Performances.vue?vue&type=template&id=0b98c500&scoped=true"
import script from "./Performances.vue?vue&type=script&lang=js"
export * from "./Performances.vue?vue&type=script&lang=js"
import style0 from "./Performances.vue?vue&type=style&index=0&id=0b98c500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98c500",
  null
  
)

export default component.exports